const publicRoute = (children: JSX.Element): JSX.Element => {
  return children;
}

export default publicRoute;
